import { createSlice } from "@reduxjs/toolkit";

export const tourSlice = createSlice({
  name: "tour",
  initialState: {
    startTour: false,
    allTours: {},
    selectedTour: [],
  },

  reducers: {
    setStartTour: (state, action) => {
      state.startTour = action.payload;
    },
    setTour: (state, action) => {
      state.selectedTour = action.payload;
    },
    removeTour: (state, action) => {
      state.selectedTour = [];
    },
  },
});

export const { setStartTour, setTour, removeTour } = tourSlice.actions;

export const getStartTour = (state) => {
  return state.tour.startTour;
};
export const getAllTours = (state) => {
  return state.tour.allTours;
};

export const getSelectedTour = (state) => {
  return state.tour.selectedTour;
};

export default tourSlice.reducer;
